import { withChartLayout } from 'components/common';
import CardiovascularAssessment from 'components/features/chart/system-assessment/cardiovascular-assessment/CardiovascularAssessment';

const CardiovascularAssessmentPage = withChartLayout('Cardiovascular Assessment')(CardiovascularAssessment);
export default CardiovascularAssessmentPage;
